/**
 * Fetch vehicles from API with dynamic query filters
 * @param {Object} filters - e.g., { make: ['Toyota'], sortBy: 'id', sortOrder: 'desc' }
 * @returns {Promise<Array>} - Fetched vehicle data
 */
export const fetchMarketPlace = async (filters = {}) => {
  try {
    // let token = await initApp();
    const params = new URLSearchParams();

    // Loop through all keys
    for (const [key, value] of Object.entries(filters)) {
      if (Array.isArray(value)) {
        value.forEach((val) => params.append(key, val));
      } else {
        params.append(key, value);
      }
    }
    const url = `https://api.futurerent.co.za/marketplace${params.toString()}`;
    const response = await fetch(url, {
      headers: {
        Authorization:
          "Bearer dHdvZHJpdmVuZXllZHVlZ292ZXJubWVudHdob2xlZ3JlYXRlc3RlcXVhbGx5Y2FiaW4=",
        // Session: token,
      },
    });

    if (!response.ok) throw new Error("Network response was not ok");

    return await response.json();
  } catch (error) {
    console.error("Failed to fetch vehicles:", error);
    throw error;
  }
};
